import { PrescriptionComponent } from './../prescription/prescription.component';
import { Component, OnInit, HostListener, TemplateRef, ViewChild } from "@angular/core";
import {
  FormArray, FormBuilder, Validators,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormArray,
  UntypedFormGroup,

} from "@angular/forms";
import {
  Message, RealTimeService,
} from "./../../service/websockets/realtime.service";
import { ActivatedRoute, CanDeactivate, Router } from "@angular/router";
import {
  ModalDismissReasons,
  NgbCalendar,
  NgbDate,
  NgbDatepickerConfig,
  NgbModal,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { PatientD } from '../../models/Pdetails';
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { VproService } from "src/app/service/vpro/vpro.service";
import { environment } from "src/environments/environment";
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { ViewEncapsulation } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ChatMessages } from "src/app/models/chat-model";
import { Physician } from "src/app/models/physician";
import { TypingStatus } from "src/app/models/typing-status";
import { Subscription } from "rxjs";
import { SocketsConnectionService } from 'src/app/service/websockets/connection.service';
import { WebsocketService } from 'src/app/service/websockets/websocket.service';

// import { ComponentCanDeactivate } from 'src/app/component-can-deactivate';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: "app-phydash",
  templateUrl: "./phydash.component.html",
  styleUrls: ["./phydash.component.scss"],
})
export class PhydashComponent implements OnInit {

  @ViewChild('PDFModal', { static: true } as any) PDFModal: TemplateRef<any>;
  @ViewChild('habitModal', { static: true } as any) habitModal: TemplateRef<any>;
  @ViewChild('lifeModal', { static: true } as any) lifeModal: TemplateRef<any>;
  @ViewChild('statsModal', { static: true } as any) statsModal: TemplateRef<any>;
  @ViewChild("joinChatNotification", { static: true } as any)
  joinChatNotification: TemplateRef<any>;

  @ViewChild("inputFile")

  u_iid = localStorage.getItem('uid');
  u_id = parseInt(this.u_iid);
  currentDt = Utils.maxDate;
  cdt = `${this.currentDt.year}-${this.currentDt.month}-${this.currentDt.day}`;

  public role = Utils.ROLE.PHYSICIAN;
  patientd = [];
  p_address_1: any;
  p_address_2: any;
  p_city_n: any;
  p_contact_no: any;
  p_dob: any;
  p_email_id: any;
  p_first_name: any;
  p_gender: any;
  p_last_name: any;
  p_ppurl: any;
  p_purl: any;
  p_state: any;
  p_zip: any;
  apdate: Date;
  since: Date;
  p_allergy: any;
  followup_date: Date;
  last_followup_date: Date;
  reason: any;
  pids: any;
  link: any; state
  dcred = new DashCred();
  pid: any;
  closeResult: string;
  PrescriptionType = Utils.PRESCRIPTIONTYPE;
  isPhyCheckOutLoading: boolean;
  aid: any;
  phydashCurrentTab: string = "patientInformation";
  phydashlistOfTabs: string[] = [
    "patientInformation",
    "diagonisDetails",
    "prescriptionGiven",
    "labTest",
    "anySpecialRemarks",
  ];
  isDisabled: boolean = true;
  phydFormList: number[] = [1];
  patient: any;
  diagnosisList: any[];
  currentPrescriptionList: any[] = [];
  previousPrescriptionList: any[] = [];
  testsList: any[];
  testsList_new: any[];
  diagnosisForm: any;
  modalForm: any;
  prescriptionForm: any;
  labTestsForm: any;
  checkinForm: any;
  drid: any;
  cid: any;
  currentDate: Date;
  momentDate: any;
  appointment: any = [];
  currentList: any = [];
  ispastapt: boolean = false;
  //appointment: any;
  app: any = [];
  labTests: FormArray;
  laboratory_tests: any[] = [];
  pdf_url = null;
  selectedLabTest = null;
  minDate = Utils.maxDate;
  stats_current: any;
  intakeList = Utils.INTAKE;
  intakeFreqTypesList = Utils.INTAKE_FREQ_TYPE_LIST;
  intakefreqList: any[] = [];
  selectedFreqType: any;
  allowedReportTypes = ".xls, .xlsx, .pdf, .png, .jpg";
  reportsToBeUploaded: any = [];
  report_attachments: FormArray;
  details: any;
  pdfSrc1: any;
  pdfSrc: any;
  fileExtension: any = [];
  onlineCheckin = true;
  public showChatModal = false;
  public notificationMessage: string = "";
  public messageAction = Utils.messageAction;
  chatForm: UntypedFormGroup;
  public currentStatus = "";
  messages: ChatMessages[] = [];
  modalRef: NgbModalRef;
  chatUserType = Utils.CHAT_USER_TYPE;
  maxFileSize = Utils.MAX_FILE_SIZE;
  attachmentSignedUrl: string;
  Imagekey: string;
  showOnlineJoinCall: boolean = false;
  isMinimize: boolean = false;
  chatStarted: boolean = false;
  public parameter: any;
  room_id: string = "";
  connection_id: string = "";
  physicianDetail: Physician;
  public chatMessageSub: Subscription;
  public chatJoinSub: Subscription;
  public typingStatus: TypingStatus;

  //  =========================================================
  freqList = [
    {
      id: 1,
      value: "Daily",
    },
    {
      id: 2,
      value: "Weekly",
    },
    {
      id: 3,
      value: "Monthly",
    },
    {
      id: 4,
      value: "Yearly",
    },
  ];
  editCurrentTab: string = "medicalInformation";
  editCurrentTabs: string[] = ["personalInformation", "medicalInformation"];
  editListOfTabs: string[] = ["personalInformation", "medicalInformation"];

  forms = {
    personalInformation: null,
    medicalInformation: null,
    patstats: null,
    diagnosisForm: null,
    appetiteHabits: null,
  };

  yearList: any[];
  current_medication: UntypedFormArray;
  appetite_habbitsList: any = [];
  patient_med_history: UntypedFormArray;
  patient_medication: UntypedFormArray;
  patient_appetite: UntypedFormArray;
  medicine_template: UntypedFormArray;
  patient_lifestyle: UntypedFormArray;
  patient_fmed_history: UntypedFormArray;
  diseaseList: any = [];
  patient_appHabbitsList: any = [];
  displayNames: any = {
    pmed_dose: "Drug Name",
    pmed_freq: "Frequency",
    habbit: "Habbit",
    disease: "Disease Name",
    duration: "Duration",
    med_hist_info: "",
    stats_std_value: "..",
    disease_id: "Disease Name",
    habit_details: "consuming qty",
    frequency: "Frequency",
    since: "",
    habit_id: "Add Habbit",
    remarks: "",
    freq: "activity frequency",
  };
  isEdited: boolean = false;


  statslist: any = [];
  pat_stats: UntypedFormArray;
  previous_stats: any;
  previous_appetite: any;
  previous_lifestyle: any;

  patient_current_consultation: any;
  p_complaints: any;
  treatment: any;
  examination: any;
  diagnosis: any;
  current_med: any;
  remarks: any;
  advice: any;
  hist_p_complaints: any;
  patstats: UntypedFormArray;
  patent_lifestyle_details: any[];
  patent_appetite_details: any[];
  pre_followup_date: Date;
  p_pre_followdate: any;
  p_pre_consultdate: any;
  p_cur_followdate: any;
  savfoldt: Date;
  curr_reason: string;
  PI_panel_expa: boolean = true;
  PH_panel_expa: boolean = false;
  PMH_panel_expa: boolean = false;
  DH_panel_expa: boolean = false;
  FMH_panel_expa: boolean = false;
  LS_panel_expa: boolean = false;
  PHS_panel_expa: boolean = false;
  PC_panel_expa: boolean = false;
  UD_panel_expa: boolean = false;
  CC_panel_expa: boolean = true;
  P_panel_expa: boolean = true;
  LT_panel_expa: boolean = true;

  panel_expa: boolean = false;
  tmpl_expa: boolean = false;
  cate: any;
  unique: any[];
  newarr: any[];
  prescriptiontmpl: UntypedFormArray;
  tmpl_search_form: UntypedFormGroup;
  prescriptiontmplForm: UntypedFormGroup;
  showAge: string;
  isEditable: boolean = true;
  aptid: string;
  onlineApt: boolean = true;
  audioCall: boolean = false;
  videoCall: boolean = false;
  isOpenSubscribe: Subscription;
  enableCallButton: boolean = false;
  maxSize = Utils.MAX_FILE_VIDEO_SIZE;
  constructor(
    //private _formBuilder: FormBuilder,
    private modalService: NgbModal,
    private modal: NgbModal,
    private patService: VproService,
    private addPService: VproService,//new
    private service: VproService,
    config: NgbDatepickerConfig,
    private spinner: NgxSpinnerService,
    private calendar: NgbCalendar,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _formBuilder: UntypedFormBuilder,
    private fb: UntypedFormBuilder,//new
    private offcanvasService: NgbOffcanvas,
    private realTimeService: RealTimeService,
    private socketsConnectionService: SocketsConnectionService,
    private wsService: WebsocketService,
  ) {
    this.currentDate = new Date();
    this.initForm();
    this.pid = this.route.snapshot.params["pid"];
    this.cid = this.route.snapshot.queryParams["cid"];
    this.fetchPatientById();
    this.momentDate = moment().format("YYYY-MM-DD");


  }

  openEnd(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end' });
  }

  openTop(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'top' });
  }

  templateForm() {


    this.tmpl_search_form = this._formBuilder.group({
      tmpl_name_org: [''],
    })


    this.prescriptiontmplForm = this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
      pre_template_details: this._formBuilder.array([]),
    });
    this.forms.appetiteHabits = this.fb.group({
      medicine_template: this._formBuilder.array([]),
    });
  }



  initForm() {

    this.forms.medicalInformation = this._formBuilder.group({
      patient_med_history: this._formBuilder.array([]),
      patient_medication: this._formBuilder.array([]),
      patient_appetite: this._formBuilder.array([]),
      medicine_template: this._formBuilder.array([]),
      patient_lifestyle: this._formBuilder.array([]),
      patient_fmed_history: this._formBuilder.array([]),
    });

    this.forms.patstats = this._formBuilder.group({
      pat_stats: this._formBuilder.array([]),
    });

    this.diagnosisForm = this._formBuilder.group({
      p_complaints: [""],
      his_p_complaints: [""],
      treatment: [""],
      examination: [""],
      diagnosis: [""],
      current_med: [""],
      remarks: [""],
      advice: [""],
      followup_date: [""],
    });

    this.prescriptionForm = this._formBuilder.group({
      prid: [""],
      mname: ["", [Validators.required, Validators.maxLength(50)]],
      strength: ["", [Validators.required, Validators.maxLength(30)]],
      intakefreq_type_id: ["", Validators.required],
      intakefreq: ["", Validators.required],
      intake: ["", Validators.required],
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
      remarks: [""],
    });

    this.labTestsForm = this._formBuilder.group({
      labTests: this._formBuilder.array([]),
    });
    this.addLabTest();

    this.checkinForm = this._formBuilder.group({
      special_remarks: [""],
    });

    this.modalForm = this._formBuilder.group({
      remarks: [""],
      review: [""],
      testid: [""],
      tstat: [""],
      report_attachments: this._formBuilder.array([]),
    });



    this.tmpl_search_form = this._formBuilder.group({
      tmpl_name_org: [''],
    })


    this.prescriptiontmplForm = this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
      pre_template_details: this._formBuilder.array([]),
    });
    this.forms.appetiteHabits = this.fb.group({
      medicine_template: this._formBuilder.array([]),
    });

  }


  ngOnInit() {

    this.drid = localStorage.getItem("uid");
    this.getPhysicianDetails();
    this.getpat();
    this.fetchPreviousDiagnosis();
    this.fetchPreviousPrescriptions();
    this.fetchPreviousLabReports();
    this.fetchExistingCheckin();
    this.fetchLaboratoryTests();
    this.getAppointment();
    this.getAppointment_document();
    this.getStatDetail();
    this.getStatsList();
    this.loadPatient();
    this.getDiseaseList();
    this.getAppHabbitList();
    this.addPatfmedhistory();
    this.getYears();
    this.initForm();

    this.chatForm = this._formBuilder.group({
      chat_msg: [""],
    });

    this.chatJoinSub = this.service.chatMessageSubject.subscribe((value) => {
      let values: ChatMessages = { ...value };
      if (values.type === Utils.NOTIFICATION_TYPES.JOIN_CHAT) {
        this.notificationMessage = values.message;
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalRef = this.modal.open(this.joinChatNotification, {
          size: "lg",
          centered: true,
          backdrop: "static",
        });
      }
    });

    this.chatForm
      .get("chat_msg")
      .valueChanges.debounceTime(2000)
      .subscribe((value) => {

        let data = { u_id: parseInt(this.pid) };
        data["id"] = parseInt(this.drid);
        data["action"] = this.messageAction.SENDMESSAGE;
        data["room_id"] = this.room_id;
        data["message"] = "";
        data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
        this.currentStatus = "";
        this.realTimeService.send(data);
        console.log("this.room_id;", this.room_id);
        console.log("Chat form Data");
      });


  }

  public removeLabTest(i: number): void {
    this.labTests.removeAt(i);
  }

  ///////////////////////////////     vinoth




  // getAppHabbitLists() {
  //   // this.addPService.getAppHabbitList().subscribe(
  //   //   // (res) => {
  //   // this.patient_appHabbitsList = res;
  //   console.log("this.cate", this.cate)
  //   for (let apetite of this.cate) {
  //     this.patient_appetite = this.forms.appetiteHabits.get(
  //       "patient_appetite"
  //     ) as UntypedFormArray;
  //     this.patient_appetite.push(this.addAppetites(apetite.id));
  //   }
  //   //   },
  //   //   (error) => { }
  //   // );
  // }


  addAppetites(id): UntypedFormGroup {
    return this._formBuilder.group({
      tmpl_id: [id],
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
    });
  }

  createMedicine(sdate, edate): UntypedFormGroup {
    return this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
    });
  }


  public getMedicineNameLabels(i) {
    return this.cate[i].mname;
  }

  public getMedicineintakeLabels(i) {
    return this.cate[i].intake;
  }
  public getMedicineintakefreqLabels(i) {
    return this.cate[i].intakefreq;
  }
  public getMedicineintakefreq_typeLabels(i) {
    return this.cate[i].intakefreq_type;
  }
  public getMedicinestrengthLabels(i) {
    return this.cate[i].strength;
  }

  ///////////////////////////////     vinoth

  public addLabTest() {
    this.labTests = this.labTestsForm.get("labTests") as FormArray;
    this.labTests.push(this.createLabTest());
  }

  createLabTest() {
    return this._formBuilder.group({
      labtest_id: ["", Validators.required],
      information: [""],
    });
  }

  freqTypeSelected(event) {
    console.log(event);
    // this.intakefreqList.length = 0;
    // console.log(this.intakefreqList);

    this.intakeFreqTypesList.forEach((type) => {
      if (type.id == event.target.value) {
        this.intakefreqList = type.freq_options;
        this.selectedFreqType = type.value;
      }
    });
    console.log(this.intakefreqList);
  }

  deleteLabtest(Labrecord) {
    console.log("Labrecord", Labrecord)
    console.log("invoice_id", Labrecord.testid)
    let Labrecord_id = Labrecord.testid
    this.spinner.show();
    this.patService.deleteLabtest(Labrecord_id).subscribe(
      (data) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 2500,
        });

        Toast.fire({
          type: "success",
          title: "Labrecord has been deleted successfuly",
        });
        console.log('Record deleted', data);
        this.fetchPreviousLabReports();
        this.fetchPreviousLabReports_new();
        this.labTestsForm.removeControl("labTests");
        this.labTestsForm.addControl("labTests", this._formBuilder.array([]));
        this.addLabTest();
      })
  }

  deletePrescription(prescriptions) {
    console.log("prescriptions", prescriptions)
    console.log("prescriptions_id", prescriptions.prid)
    let prescriptions_id = prescriptions.prid
    this.patService.deletePrescri(prescriptions_id).subscribe(
      (data) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 2500,
        });

        Toast.fire({
          type: "success",
          title: "prescriptions has been deleted successfuly",
        });
        console.log('Record deleted', data);
        this.fetchPreviousPrescriptions();
        this.prescriptionForm.reset();

        this.prescriptionForm = this._formBuilder.group({
          prid: [""],
          mname: ["", [Validators.required, Validators.maxLength(50)]],
          strength: ["", [Validators.required, Validators.maxLength(30)]],
          intakefreq_type_id: ["", Validators.required],
          intakefreq: ["", Validators.required],
          intake: ["", Validators.required],
          sdate: [null, Validators.required],
          edate: [null, Validators.required],
          remarks: [""],
        });


      })
  }
  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }


  fetchLaboratoryTests() {
    this.patService.getLaboratoryTests().subscribe((result) => {
      this.laboratory_tests = result;
    });
  }

  fetchExistingCheckin() {
    this.patService
      .fetchCheckinById({ pid: this.pid, cid: this.cid })
      .subscribe((result) => {
        console.log("FetchExistingCheckinetchExistingCheckin", result);
        this.checkinForm.patchValue(result);
        if (result.chkstatus == "Completed") {
          this.isEditable = false;
        }
      });
  }

  //get the previous appointments 
  getAppointment() {
    this.spinner.show();
    this.aid = this.cid;
    console.log("aid", this.aid)
    // if (this.aptid) {
    //   this.room_id = this.aptid;
    // }

    this.patService
      .getAppointmentDetails({
        pids: this.pid,
        fields: [
          "appointment_details",
        ],
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.appointment = res;
          console.log("this.appointment.Current_stats ====================", this.appointment);

          if (res && res.length > 0) {
            res.forEach((record) => {
              if (record.aid == this.aid) {
                console.log("CurrentList ====================", record.aid);
                this.ispastapt = true;
              }
            });
          }

        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  alphabetically(ascending) {

    return function (a, b) {
      // equal items sort equally
      if (a[0].ap_date === b[0].ap_date) {
        return 0;
      }

      // nulls sort after anything else
      if (a[0].ap_date === null) {
        return 1;
      }
      if (b[0].ap_date === null) {
        return -1;
      }
      console.log("a", a[0].ap_date)
      console.log("b", b[0].ap_date)
      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a[0].ap_date < b[0].ap_date ? -1 : 1;
      }

      // if descending, highest sorts first
      return a[0].ap_date < b[0].ap_date ? 1 : -1;

    };
  }

  fetchPreviousLabReports() {
    this.patService.
      fetchPatientTestsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log(result);
        this.testsList = result.reverse();
        console.log("this.testsList", this.testsList)

        let fileName, filen;

        for (var i = 0; i < this.testsList.length; i++) {

          filen = this.testsList[i].attachments;

          if (filen) {
            for (var j = 0; j < filen.length; j++) {
              var filenn = filen[j];
              if (filenn) {
                this.fileExtension.push(filen[j].split('?')[0].split('.').pop());

              }

            }
            this.testsList[i].attachments['ext'] = this.fileExtension;
            this.fileExtension = [];
          }

        }
        console.log("this.testsList::", this.testsList);

      });
  }

  fetchPreviousLabReports_new() {
    this.patService.
      fetchAppointTestsByPhysician({ pid: this.pid, aid: this.cid })
      //fetchPatientTestsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log(result);
        this.testsList_new = result;
        console.log("this.testsList", this.testsList_new)
      });
  }

  fetchPreviousPrescriptions() {
    this.previousPrescriptionList = [];
    this.currentPrescriptionList = [];
    this.patService
      .fetchPatientPrescriptionsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log(result);
        if (result && result.length > 0) {
          result.forEach((record) => {
            if (moment(record.edate).format("YYYY-MM-DD") >= this.momentDate) {
              this.currentPrescriptionList.push(record);
              console.log("this.currentPrescriptionList1", this.currentPrescriptionList)
            } else {
              this.previousPrescriptionList.push(record);
            }
          });
        }
      });
  }
  fetchPreviousPrescriptionsTemplates() {
    this.previousPrescriptionList = [];
    this.currentPrescriptionList = [];
    this.patService
      .fetchPatientPrescriptionsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log(result);
        if (result && result.length > 0) {
          result.forEach((record) => {
            // console.log("this.record", record)
            // console.log("this.momentDate", this.momentDate)
            // console.log("moment(record.edate)", moment(record.edate).format("YYYY-MM-DD"))
            if (moment(record.edate).format("YYYY-MM-DD") >= this.momentDate) {
              console.log("this.record", record)
              // this.currentPrescriptionList = [];
              // this.currentPrescriptionList.push(record);
              // this.currentPrescriptionList = [record];
              this.currentPrescriptionList.push(record);

            } else {

              this.previousPrescriptionList = result;
            }

          });
        }
      });
    console.log("this.currentPrescriptionList1", this.currentPrescriptionList)
  }
  fetchPreviousDiagnosis() {
    let dgdate = new NgbDate(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      this.currentDate.getDate()
    );
    this.diagnosisForm.patchValue({ dgdate: dgdate });
    this.patService
      .fetchPatientDiagnosisByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log("fetchPatientDiagnosisByPhysician", result);
        // this.diagnosisList = result.sort().reverse();
        this.diagnosisList = result;
        console.log("result", result)
        console.log("this.diagnosisList", this.diagnosisList)
      });
  }

  fetchPatientById() {
    this.isPhyCheckOutLoading = true;
    this.patService.fetchPatientByAId(this.pid, this.cid).subscribe((result) => {
      console.log("this.pid:", this.pid);
      console.log("Personel INFO:", result);
      this.patient = result;
      this.isPhyCheckOutLoading = false;

      let fdate = moment(this.patient.dob).format("DD-MM-YYYY");
      var contractMoment = moment(fdate, 'DD-MM-YYYY');
      let a = moment();
      let age = moment.duration(a.diff(contractMoment));
      let years = age.years();
      let months = age.months();
      let days = age.days();
      this.showAge = years + " y " + months + " m " + days + " d "
    });
  }

  editPrescription(prescription) {
    console.log(prescription);
    let updatedPrescription: any = {};
    Object.assign(updatedPrescription, prescription);
    if (updatedPrescription.sdate) {
      let sdate = new Date(updatedPrescription.sdate);
      delete updatedPrescription.sdate;
      updatedPrescription.sdate = new NgbDate(
        sdate.getFullYear(),
        sdate.getMonth() + 1,
        sdate.getDate()
      );
    }
    if (updatedPrescription.edate) {
      let edate = new Date(updatedPrescription.edate);
      delete updatedPrescription.edate;
      updatedPrescription.edate = new NgbDate(
        edate.getFullYear(),
        edate.getMonth() + 1,
        edate.getDate()
      );
    }
    this.intakeFreqTypesList.forEach((type) => {
      if (type.value == prescription.intakefreq_type) {
        updatedPrescription.intakefreq_type_id = type.id;
      }
    });
    this.prescriptionForm.patchValue(updatedPrescription);
  }
  submitPrescription(values) {
    console.log("values values", values)
    console.log(values);
    values.sdate = `${values.sdate.year}-${values.sdate.month}-${values.sdate.day}`;
    values.edate = `${values.edate.year}-${values.edate.month}-${values.edate.day}`;
    values.intakefreq_type = this.selectedFreqType;
    delete values.intakefreq_type_id;
    if (values.prid && !isNaN(values.prid)) {
      values.prescuptime = moment().format("YYYY-MM-DD HH:mm:ss");
      this.patService
        .updatePrescription(this.pid, values)
        .subscribe((result) => {
          this.showToast("success", "Prescription updated successfully");
          this.fetchPreviousPrescriptions();
          this.prescriptionForm.reset();
          this.tmpl_search_form.reset();

          this.prescriptionForm = this._formBuilder.group({
            prid: [""],
            mname: ["", [Validators.required, Validators.maxLength(50)]],
            strength: ["", [Validators.required, Validators.maxLength(30)]],
            intakefreq_type_id: ["", Validators.required],
            intakefreq: ["", Validators.required],
            intake: ["", Validators.required],
            sdate: [null, Validators.required],
            edate: [null, Validators.required],
            remarks: [""],
          });

        });
    } else {
      delete values.prid;
      values.pdate = this.momentDate;
      values.pid = this.pid;
      values.drid = this.drid;
      values.cid = this.cid;
      this.patService
        .addPrescription({ prescription: [values] })
        .subscribe((result) => {
          this.showToast("success", "Prescription added successfully");
          this.fetchPreviousPrescriptions();
          this.prescriptionForm.reset();
          this.tmpl_search_form.reset();

          this.prescriptionForm = this._formBuilder.group({
            prid: [""],
            mname: ["", [Validators.required, Validators.maxLength(50)]],
            strength: ["", [Validators.required, Validators.maxLength(30)]],
            intakefreq_type_id: ["", Validators.required],
            intakefreq: ["", Validators.required],
            intake: ["", Validators.required],
            sdate: [null, Validators.required],
            edate: [null, Validators.required],
            remarks: [""],
          });

        });
      this.prescriptionForm = this._formBuilder.group({
        prid: [""],
        mname: ["", [Validators.required, Validators.maxLength(50)]],
        strength: ["", [Validators.required, Validators.maxLength(30)]],
        intakefreq_type_id: ["", Validators.required],
        intakefreq: ["", Validators.required],
        intake: ["", Validators.required],
        sdate: [null, Validators.required],
        edate: [null, Validators.required],
        remarks: [""],
      });
    }
  }
  submitPrescriptionTemplate(temp_id) {
    this.panel_expa = false;
    // this.tmpl_expa = false;
    setTimeout(() => {
      this.fetchPreviousPrescriptions();
    }, 200);
    let data = {
      ...this.forms.appetiteHabits.value,
    };
    data.medicine_template.forEach((record, index) => {

      let values = data.medicine_template[index];
      console.log("VALUES", values);


      if (temp_id === values.tmpl_id) {
        // if (values.sdate === null && values.edate === null) {
        //   this.showToast("warning", "Some prescription missing");
        //   return null;
        // }

        if (values.sdate != null && values.edate != null) {
          values.sdate = `${values.sdate.year}-${values.sdate.month}-${values.sdate.day}`;
          values.edate = `${values.edate.year}-${values.edate.month}-${values.edate.day}`;
          values.mname = this.cate[index].mname;
          values.intake = this.cate[index].intake;
          values.intakefreq = this.cate[index].intakefreq;
          values.intakefreq_type = this.cate[index].intakefreq_type;
          values.strength = this.cate[index].strength;
          values.remarks = null;
          delete values.intakefreq_type_id;
          delete values.tmpl_id;
          delete values.prid;
          values.pdate = this.momentDate;
          values.pid = this.pid;
          values.drid = this.drid;
          values.cid = this.cid;
          this.patService
            .addPrescription({ prescription: [values] })
            .subscribe((result) => {
              this.showToast("success", "Prescription added successfully");
            });
        }
      }
      else {
        delete values.sdate
        delete values.edate
        delete values.mname
        delete values.tmpl_id
        delete values.intake
        delete values.intakefreq
        delete values.strength
        delete values.remarks
        delete values.intakefreq_type_id;
      }
    });
    // this.fetchPreviousPrescriptions();
    this.tmpl_expa = false;
  }

  submitLabTests(values) {
    if (values.labTests.length > 0) {
      let labTestRecords = [];
      values.labTests.forEach((test) => {
        if (test.labtest_id) {
          let labTest = {
            pid: this.pid,
            drid: this.drid,
            cid: this.cid,
            labtest_id: test.labtest_id,
            remarks: test.information,
            tstat: "Ordered",
            tdate: this.momentDate,
          };
          labTestRecords.push(labTest);
        }
      });
      this.patService
        .addLabTests({ lab_tests: labTestRecords }, this.pid)
        .subscribe((result) => {
          this.showToast('success', "Record added successfully");
          this.fetchPreviousLabReports();
          this.fetchPreviousLabReports_new()
          //this.fetchlabreport(this.cid, this.pid);
          this.labTestsForm.removeControl("labTests");
          this.labTestsForm.addControl("labTests", this._formBuilder.array([]));
          this.addLabTest();
        });
    }
  }

  submitCheckinForm(values) {
    values.cid = this.cid;
    delete values.pid;
    this.patService.updateCheckin(this.pid, values).subscribe((result) => {
      this.showToast('success', "Record submitted successfully");
      setTimeout(x => {
        this.refresh();
      }, 3000)
    });
  }

  refresh(): void {
    window.location.reload();
  }

  completeAppointment() {
    Swal.fire({
      title: 'Complete appointment',
      text: " Are you sure ?",
      type: 'info',
      showCancelButton: true,
      buttonsStyling: true,
      confirmButtonClass: 'btn btn-danger',
      confirmButtonText: 'Yes',
      cancelButtonClass: 'btn btn-secondary'
    }).then((result) => {
      if (result.value) {
        //this.spinner.show();
        let appointment = {
          status: Utils.APPOINTMENT_STATUS.COMPLETED,
        }
        let aid = this.cid;
        this.patService.editSchedule(appointment, aid).subscribe(res => {
          this.spinner.hide();
          this.showToast('success', res);
          this.router.navigate(["/appointment/consultation"]);
        })

      }
    })

  } catch(excep) {
    console.log(excep)
  }

  printPage(eve) {
    console.log('eventttttttttttt', eve);
    let data = {
      aid: parseInt(this.cid),
    }
    console.log('dataaaaaaaaaaaa', data);
    console.log('this.currentPrescriptionList', this.currentPrescriptionList);
    if (eve.target.id === this.PrescriptionType.CURRENTPRESCRIPTION) {
      data['prescription'] = this.currentPrescriptionList;
      this.patService.CurrentPrescriptionPdf(data, `?type=offine_prescription`).subscribe((result) => {
        if (result) {

          this.pdf_url = environment.content_base_url + "/" + result;
          window.open(this.pdf_url);
        }
      });
    }
    if (eve.target.id === this.PrescriptionType.PREVIOUSPRESCRIPTION) {
      data['prescription'] = this.previousPrescriptionList;
      this.patService.CurrentPrescriptionPdf(data, `?type=offine_prescription&past_medication=true`,).subscribe((result) => {
        if (result) {
          this.pdf_url = environment.content_base_url + "/" + result;
          window.open(this.pdf_url);
        }
      });

    }
    this.pdf_url = "";
  }


  printPagee(eve) {
    let data = {
      aid: parseInt(this.aid),

    }
    data['labrecord'] = this.testsList;
    this.patService.CurrentPrescriptionPdf(data, `?type=offine_lab`).subscribe((result) => {
      if (result) {
        this.pdf_url = environment.content_base_url + "/" + result;
        window.open(this.pdf_url);
      }
    });
    this.pdf_url = "";
  }

  disableCB() {
    document.getElementById("myCheck").hidden = true;
  }

  enableCB() {
    document.getElementById("myCheck").hidden = false;
  }

  public phydashAssignTab(tabName: string): void {
    this.phydashCurrentTab = tabName;
  }

  /** adding more medical history */
  public addingMorTestHistory(): void {
    this.phydFormList.push(1);
  }
  /** removing current medical history */
  public removingCurrentTestHiostory(i: number): void {
    this.phydFormList.splice(i, 1);
  }

  /** next tabs based on next click by user */
  public phydashNextTab(): void {
    let index = this.phydashlistOfTabs.indexOf(this.phydashCurrentTab);
    this.phydashCurrentTab = this.phydashlistOfTabs[index + 1];
  }
  /** get previous tabname and info */
  public phydashPreviousTab(): void {
    let index = this.phydashlistOfTabs.indexOf(this.phydashCurrentTab);
    this.phydashCurrentTab = this.phydashlistOfTabs[index - 1];
  }

  uploadReports(files) {
    this.reportsToBeUploaded = [];
    if (files && files.length > 0) {
      Object.keys(files).forEach((key) => {
        if (key != "length") {
          this.reportsToBeUploaded.push(files[key]);
        }
      });
    }
    console.log(this.reportsToBeUploaded);
  }

  openEditLabTest(content, record) {
    this.modalForm.removeControl("report_attachments");
    this.modalForm.addControl(
      "report_attachments",
      this._formBuilder.array([])
    );
    this.report_attachments = this.modalForm.get(
      "report_attachments"
    ) as FormArray;

    if (record.attachments && record.attachments.length > 0) {
      record.attachments.forEach((attachment) => {
        this.report_attachments.push(
          this._formBuilder.group({
            s3Key: [attachment],
          })
        );
      });
    }
    this.modalForm.patchValue({
      testid: record.testid,
      review: record.review,
      remarks: record.remarks,
    });
    console.log(this.modalForm);
    this.selectedLabTest = record;
    this.modalService
      .open(content, { windowClass: "bloodTestModal" })
      .result.then(
        (result) => {
          this.selectedLabTest = null;
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.selectedLabTest = null;
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }



  openPrevhabit(): void {
    this.modal.open(this.habitModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  openPrevlife(): void {
    this.modal.open(this.lifeModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  openPrestats(stats_id): void {
    //this.fetchPreviousPrescriptions(aid, pid);
    //this.aaid = aid;
    console.log("openPrestats(stats_id)", stats_id);
    console.log("stats_id", this.statslist[stats_id].id);
    let id = this.statslist[stats_id].id;
    console.log(this.statslist);
    this.getPreviousStatDetail(id);
    this.modal.open(this.statsModal, { size: 'lg', centered: true, backdrop: 'static' });
  }




  updateLabTest(input) {
    input.tstat = "Reviewed";
    input.pid = this.pid;
    input.org_code = localStorage.getItem("orgcode");
    input.attachments = this.reportsToBeUploaded.map((report) => {
      return { name: report.name, content_type: report.type };
    });
    input.existingKeys = input.report_attachments.map((item) =>
      item.s3Key.replace(`${environment.content_base_url}/`, "")
    );
    delete input.report_attachments;
    console.log(input);
    this.spinner.show();
    this.patService
      .updateLabtest(this.pid, input, this.reportsToBeUploaded)
      .subscribe(() => {
        this.spinner.hide();
        this.showToast('success', "Record updated successfully");
        this.reportsToBeUploaded = [];
        this.fetchPreviousLabReports();
        //this.fetchlabreport(this.aid, this.pid);
      });
  }

  deleteAttachment(i) {
    this.report_attachments.removeAt(i);
  }

  getback() {
    this.location.back();
  }

  //showToast function
  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }


  toDisplay = false;

  toggleData() {
    this.spinner.show();
    this.toDisplay = !this.toDisplay;
    this.spinner.hide();
  }

  patientinformation() {
    let e = document.getElementById("patientinformation");
    e.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  healthstatistics() {
    let f = document.getElementById("healthstats");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    f.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  history() {
    let g = document.getElementById("history");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  pconsultations() {
    let g = document.getElementById("pconsultations");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  cconsultation() {
    let g = document.getElementById("cconsultation");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }
  lifestyle() {
    let g = document.getElementById("lifestyle");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  presc() {
    let g = document.getElementById("presc");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  updocs() {
    let g = document.getElementById("updocs");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  habits() {
    let g = document.getElementById("habits");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }

  labtes() {
    let g = document.getElementById("labtes");
    // This ends the block to the window 
    // bottom and also aligns the view to the center 
    g.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start'
    });
  }


  //fetch the documents when you upload on checkin screen
  getAppointment_document() {
    this.spinner.show();
    this.service.getAppointmentDetails(
      {
        aid: this.aid, fields: ["documents"]
      }).subscribe(res => {
        this.spinner.hide();
        this.details = res;

        console.log("this.details", this.details.length)
        if (this.details && this.details.length > 0) {
          this.details.forEach((element, index) => {
            if (element.key && element.key.length > 0 && element.key.includes('/')) {
              let file = element.key.split('/');
              if (file && file.length > 0)
                this.details[index]['name'] = file.pop();
            }
          });
        }
      }, error => {
        this.spinner.hide();
        this.showToast('error', "Something went wrong. Please try again.");
      });
  }

  // Preview document fetch function
  async previewDocument(doc: any) {
    if (doc && doc.key && doc.key.length > 0) {
      let uri = environment.content_base_url + "/" + doc.key;
      console.log("uri:::", uri);
      if (Utils.allowedImageFormats.includes(doc.key.split('.').pop())) {
        Swal.fire({
          imageUrl: uri,
          showConfirmButton: false,
          showCloseButton: true,
        })
      } else {
        this.pdfSrc1 = doc;
        console.log(this.pdfSrc1);
        const files = { name: doc.name, type: doc.type };
        this.pdfSrc = uri;
        console.log("Files:::", files);
        console.log("pdfSrc:::", this.pdfSrc);
        this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });
      }
    }
  }

  // Close model Function
  closeModal() {
    this.modal.dismissAll();
  }

  closeVideoScreen() {
    let video: any = document.querySelector("#preview > video");
    if (video && video.srcObject) {
      for (const track of video.srcObject.getTracks()) {
        track.stop();
      }
      video.srcObject = null;
    }
    this.showOnlineJoinCall = false;
    this.isMinimize = false;
  }

  public minimize() {
    this.isMinimize = true;
  }

  public maximize() {
    this.isMinimize = false;
  }


  // Download document when you upload on checkin screen

  downloadDocument(doc) {
    if (doc && doc.signedUrl) {
      Utils.downloadFileWithSignedUrl(doc);
    } else {
      Utils.downloadFile(doc);
    }
  }

  //view existing  appointments
  viewexistingappt(pid, aid) {

    this.link = [`/#/phydash/${pid}?cid=${aid}`];
    window.open(this.link, '_blank');

  }

  // Smooth Scroll
  showScroll: boolean;
  showScrollHeight = 200;
  hideScrollHeight = 200;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      ) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (this.showScroll &&
      (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }



  scrollToTop() {
    (function smoothscroll() {
      const currentScroll = (document.documentElement.scrollTop || document.body.scrollTop);
      if (currentScroll > 0) {
        window.scrollTo(0, currentScroll - (currentScroll));
      }
    })();
  }

  // Preview Docs on round image
  imgSrc: string;

  onClick(event) {
    const imgElem = event.target;

    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;

  }


  //========================================================================================//

  getpat() {
    this.patService.getpat(this.cid).subscribe(data => {
      let i = 0, ithvalue;
      var leng = data.length;
      console.log("data Length", leng);
      console.log("consultations:", data);
      if (data && data.length > 0) {
        data.forEach((record) => {
          if (record.cid == this.aid) {
            // console.log("CurrentList ====================", record.aid);
            console.log("===================", i);
            ithvalue = i;
            this.curr_reason = record.reason;
            this.savfoldt = record.followup_date;
          } i = i + 1;
        });
      }
      console.log("========ithvalue========", ithvalue);
      this.patientd = data;
      console.log(" this.patientd  this.patientd ", this.patientd);
      this.p_cur_followdate = data[0].cur_followdate;
      if (data[0].pre_followdate) {
        this.p_pre_followdate = data[0].pre_followdate;
      }
      if (data[0].pre_consult_date) {
        this.p_pre_consultdate = data[0].pre_consult_date;
      }
      this.p_address_1 = data[0].address_1;
      this.p_address_2 = data[0].address_2;
      this.p_city_n = data[0].city_n;
      this.p_contact_no = data[0].contact_no;
      this.p_dob = data[0].dob;
      this.p_email_id = data[0].email_id;
      this.p_first_name = data[0].first_name;
      this.p_gender = data[0].gender;
      this.p_last_name = data[0].last_name;
      this.p_ppurl = data[0].ppurl;
      this.p_state = data[0].state;
      this.p_zip = data[0].zip;
      this.p_allergy = data[0].allergy;
      console.log("iooooooooooooouiiiiiiiiiiiiii ", this.p_first_name);
      console.log("iooooooooooooouiiiiiiiiiiiiii ", this.p_allergy);
      this.p_purl = environment.content_base_url + "/" + this.p_ppurl;
      // console.log("p_address_1 ", this.p_address_1);
      this.since = data[0].apdate;
      if (leng == 1) {
        this.apdate = null;
        this.followup_date = null;
      } else {
        this.apdate = data[leng - 2].apdate;
        this.followup_date = data[leng - 2].followup_date;
      }
      this.reason = data[leng - 1].reason;
      this.pids = data[0].pid;

      data.forEach((x, index) => {
        if (x.cid == this.cid) {
          this.reason = x.reason;
          // this.aptime = x.aptime;
          // this.endtime = x.endtime;
          // this.aptdate = x.apdate;
          //this.dr_id = x.drid;
          this.onlineCheckin = x.online_checkin;
          this.room_id = x.aptid;
          console.log("this.room_id ", this.room_id);
          //this.pid = x.pid;
        }
      });
      this.updateRoomId();
    });
  }



  loadPatient() {
    // console.log("qqqqqqqwwwwwwwwwwwwwwwwwww", this.pid);
    this.spinner.show();
    this.service.fetchPatientByAId(this.pid, this.cid).subscribe(
      (response) => {
        this.spinner.hide();
        if (response) {
          // console.log("response", response)
          this.patient = response;
          if (response.patient_current_consultation) {
            this.patient_current_consultation = response.patient_current_consultation;
          }
          if (this.patient_current_consultation[0]) {
            this.p_complaints = this.patient_current_consultation[0].p_complaints;
            console.log("this.p_complaints", this.p_complaints)
            this.hist_p_complaints = this.patient_current_consultation[0].hist_p_complaints;
            this.treatment = this.patient_current_consultation[0].treatment;
            this.examination = this.patient_current_consultation[0].examination;
            this.diagnosis = this.patient_current_consultation[0].diagnosis;
            this.current_med = this.patient_current_consultation[0].curr_med;
            this.remarks = this.patient_current_consultation[0].remarks;
            this.advice = this.patient_current_consultation[0].advice;
          }

          this.previous_appetite = response.patient_appetite_all;
          this.previous_lifestyle = response.patient_lifestyle_all;
          console.log("loadPatient()::", this.patient);
          this.get_patient_lifestyle_all();
          this.get_patient_appetite_all();
          console.log("-------------------------------------------------", this.previous_lifestyle)
          this.addHistory();
          this.addMedication();
          this.addAppetite();
          this.addLifestyle();
          this.addStatistis();
          this.addPatfmedhistory();
        }
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }




  getControl(field: string): UntypedFormControl {
    if (field == "patient_medication" || field == "medicine_template" || field == "patient_appetite" || field == "patient_med_history" || field == "patient_lifestyle" || field == "patient_fmed_history" || field == "pat_stats") {
      return this.forms[this.editCurrentTabs[1]].get(field) as UntypedFormControl;
    }
    else {

      return this.forms[this.editCurrentTabs[0]].get(field) as UntypedFormControl;
    }
    // return this.forms[this.editCurrentTab].get(field) as UntypedFormControl;
  }

  getAppHabbitList() {
    this.service.getAppHabbitList().subscribe((res) => {
      this.patient_appHabbitsList = res;
    });
  }

  getDiseaseList() {
    this.service.getDiseaseList().subscribe((res) => {
      this.diseaseList = res;
    });
  }

  createHistory(id, years, info): UntypedFormGroup {
    return this._formBuilder.group({
      disease_id: [id, [Validators.required]],
      // med_hist_year: [years, [Validators.required]],
      med_hist_info: [info],
      since: [years, [Validators.required]]
    });
  }

  createMedication(pmed_dose, pmed_freq, since): UntypedFormGroup {
    return this._formBuilder.group({
      pmed_dose: [pmed_dose],
      pmed_freq: [pmed_freq],
      since: [since],
    });
  }

  createApetite(habit_id, habit_details, has_habit, frequency, since, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      habit_details: [habit_details],
      habit_id: [habit_id],
      has_habit: [has_habit],
      frequency: [frequency],
      since: [since],
      createdby: [this.u_id],
      createdat: [this.cdt],
    });
  }

  createLifestyle(activity, duration, freq, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      activity: [activity],
      duration: [duration],
      freq: [freq],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }

  createPatfmedhistory(relation, diabetic, cardio, tension, cholestral, status, remarks): UntypedFormGroup {
    return this._formBuilder.group({
      relation: [relation],
      diabetic: [diabetic],
      tension: [tension],
      cholestral: [cholestral],
      cardio: [cardio],
      status: [status],
      remarks: [remarks],

    });
  }

  addHistory() {
    if (this.patient && this.patient.patient_med_history) {
      for (let item of this.patient.patient_med_history) {
        this.patient_med_history = this.forms.medicalInformation.get(
          "patient_med_history"
        ) as UntypedFormArray;
        this.patient_med_history.push(
          this.createHistory(
            item.disease_id,
            item.since,
            item.med_hist_info,

          )
        );
      }
    }
  }

  addMedication() {
    if (this.patient && this.patient.patient_medication) {
      for (let item of this.patient.patient_medication) {
        this.patient_medication = this.forms.medicalInformation.get(
          "patient_medication"
        ) as UntypedFormArray;
        this.patient_medication.push(
          this.createMedication(item.pmed_dose, item.pmed_freq, item.since)
        );
      }
    }
  }

  addLifestyle() {
    if (this.patient && this.patient.patient_lifestyle) {
      for (let item of this.patient.patient_lifestyle) {
        this.patient_lifestyle = this.forms.medicalInformation.get(
          "patient_lifestyle"
        ) as UntypedFormArray;
        this.patient_lifestyle.push(
          this.createLifestyle(item.activity, item.duration, item.freq, item.createdby, item.createdat)
        );
      }
    }
  }

  addPatfmedhistory() {
    if (this.patient && this.patient.patient_fmed_history) {
      for (let item of this.patient.patient_fmed_history) {
        this.patient_fmed_history = this.forms.medicalInformation.get(
          "patient_fmed_history"
        ) as UntypedFormArray;
        this.patient_fmed_history.push(
          this.createPatfmedhistory(item.relation, item.diabetic, item.cardio, item.tension, item.cholestral, item.status, item.remarks)
        );
      }
    }
  }

  addStatistis() {
    if (this.stats_current) {
      for (let item of this.stats_current) {
        console.log("item.stats_std_value", item.stats_name)
        this.pat_stats = this.forms.patstats.get(
          "pat_stats"
        ) as UntypedFormArray;
        this.pat_stats.push(
          this.createStats(item.stats_std_val, item.stats_name, item.stats_std_uom, item.stats_id)
        );
      }
    }
  }
  createStats(stats_std_value, stats_name, stats_std_uom, stats_id): UntypedFormGroup {
    return this._formBuilder.group({
      stats_std_value: [stats_std_value],
      stats_name: [stats_name],
      stats_std_uom: [stats_std_uom],
      stats_id: [stats_id],
    });
  }



  addAppetite() {
    if (this.patient && this.patient.patient_appetite) {
      for (let item of this.patient.patient_appetite) {
        this.patient_appetite = this.forms.medicalInformation.get(
          "patient_appetite"
        ) as UntypedFormArray;
        this.patient_appetite.push(
          this.createApetite(item.habit_id, item.habit_details, item.has_habit, item.frequency, item.since, item.createdby, item.createdat)
        );
      }
    }
  }



  /** assign tabs based on click */
  public editAssignTab(tabName: string): void {
    this.editCurrentTab = tabName;
  }

  /** next tabs based on next click by user */
  public editNextTab(): void {
    let index = this.editListOfTabs.indexOf(this.editCurrentTab);
    this.editCurrentTab = this.editListOfTabs[index + 1];
  }
  /** get previous tabname and info */
  public editPreviousTab(): void {
    let index = this.editListOfTabs.indexOf(this.editCurrentTab);
    this.editCurrentTab = this.editListOfTabs[index - 1];
  }

  updateField(field: string) {
    const control = this.getControl(field);
    if (control.valid) {
      this.patient = {
        ...this.patient,
        [field]: control.value,
      };
    }
  }
  updateStats(field: string) {
    const control = this.getControl(field);
    if (control.valid) {
      this.stats_current = {
        ...this.stats_current,
        [field]: control.value,
      };
    }
  }



  get_patient_appetite_all() {
    var arr = this.previous_appetite;
    let count = this.patient.patient_appetite.length

    var i = 0, res = [], tempArr = [];
    while (i < arr.length) {
      if (i !== 0 && i % count === 0) {
        res.push(tempArr);
        tempArr = [arr[i]];
      } else {
        tempArr.push(arr[i]);
      }
      i++;
    }
    res.push(tempArr);
    console.log(res);
    this.patent_appetite_details = res.sort(this.alphabetically(false))
  }

  get_patient_lifestyle_all() {

    var arr = this.previous_lifestyle;
    let count = this.patient.patient_lifestyle.length

    var i = 0, res = [], tempArr = [];
    while (i < arr.length) {
      if (i !== 0 && i % count === 0) {
        res.push(tempArr);
        tempArr = [arr[i]];
      } else {
        tempArr.push(arr[i]);
      }
      i++;
    }
    res.push(tempArr);
    this.patent_lifestyle_details = res.sort(this.alphabetically(false))
  }
  //==============================================================================//

  //SAVE AND COMPLETE CONSULTATION  updatePatient()

  public updatePatient() {


    var pid, cid, newreas;
    var today = new Date();
    var date = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    var current_date = year + '-' + month + '-' + date;
    let data = {
      ...this.forms.medicalInformation.value,
      ...this.forms.patstats.value,
      pid: parseInt(this.pids),
      drid: parseInt(this.drid),
      aid: parseInt(this.aid),

      ...this.diagnosisForm.value
    };
    console.log("===========================", data)
    if (data['followup_date']) {
      data['followup_date'] = `${data['followup_date'].year}-${data['followup_date'].month}-${data['followup_date'].day}`;
    }
    if (data.patient_fmed_history) {
      delete data.patient_fmed_history;
    }
    if (data.patient_med_history) {
      delete data.patient_med_history;
    }
    if (data.patient_medication) {
      delete data.patient_medication;
    }
    if (data.pat_stats && data.pat_stats.length === 0) {
      delete data.pat_stats;
    }
    console.log("stats_current.cu", this.stats_current)
    if (data.pat_stats && data.pat_stats.length > 0) {
      //this.forms.reasonForm.value;
      var stats_std_val;
      data.pat_stats.forEach((x, index) => {
        x.stats_std_val = String(x.stats_std_value);
        x.aid = parseInt(this.cid);
        x.pid = parseInt(this.pids);
        x.stats_date_time = current_date;
        x.id = this.stats_current[index].id
        x.stats_by = this.drid;
        delete x.stats_std_value;
        delete x.stats_std_uom;
        delete x.stats_name;
      });
    }
    data.patient_consult_stats = data.pat_stats;
    delete data.pat_stats;
    if (data.patient_checkin_stats && data.patient_checkin_stats.length === 0) {
      delete data.patient_checkin_stats;
    }
    data = Utils.removeNullAndEmpty(data);
    console.log("data.patient_appetite", data.patient_appetite)
    if (data.patient_appetite && data.patient_appetite.length > 0) {
      data.patient_appetite.forEach((x, index) => {

        if (x.since === '') {
          console.log("since is empty");
          x.since = 0;
          //delete (x.since)
        }
        x.ap_date = current_date;
        data.patient_appetite[index] = Utils.removeNullAndUndefined(
          data.patient_appetite[index]
        );
      });
    }
    if (data.patient_lifestyle && data.patient_lifestyle.length > 0) {
      data.patient_lifestyle.forEach((x, index) => {
        x.ap_date = current_date;
        data.patient_lifestyle[index] = Utils.removeNullAndUndefined(
          data.patient_lifestyle[index]
        );
      });
    }
    if (data.patient_appetite && data.patient_appetite.length === 0) {
      delete data.patient_appetite;
    }
    if (data.patient_appetite) {
      data.patient_consult_appetite = data.patient_appetite
      delete data.patient_appetite;
    }
    if (data.patient_lifestyle) {
      data.patient_consult_lifestyle = data.patient_lifestyle
      delete data.patient_lifestyle;
    }
    console.log("--------------DATA-----------------------", data);
    this.spinner.show();
    this.addPService.saveConsult_dtails(data).subscribe(
      () => {
        let appointment = {
          status: Utils.APPOINTMENT_STATUS.COMPLETED,
        }
        let aid = this.aid;

        this.patService.editSchedule(appointment, aid).subscribe(res => {
          this.spinner.hide();
          this.showToast('success', "Consultation Completed");
          this.router.navigate(["/appointment/consultation"]);
        }, (error) => {
          this.spinner.hide();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          console.log("error", error.error.error)
          Toast.fire({
            type: "error",
            title: error.error.error,
          });
        })
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  //==============================================================================//

  // ONLY SAVE  THIS CONSULTATION  savePatient()

  public savePatient() {


    var pid, cid, newreas;
    var today = new Date();
    var date = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    var current_date = year + '-' + month + '-' + date;
    let data = {
      ...this.forms.medicalInformation.value,
      ...this.forms.patstats.value,
      pid: parseInt(this.pids),
      drid: parseInt(this.drid),
      aid: parseInt(this.aid),

      ...this.diagnosisForm.value
    };
    console.log("===========================", data)
    if (data['followup_date']) {
      data['followup_date'] = `${data['followup_date'].year}-${data['followup_date'].month}-${data['followup_date'].day}`;
    }

    if (data.patient_fmed_history) {
      delete data.patient_fmed_history;
    }
    if (data.patient_med_history) {
      delete data.patient_med_history;
    }
    if (data.patient_medication) {
      delete data.patient_medication;
    }
    if (data.pat_stats && data.pat_stats.length === 0) {
      delete data.pat_stats;
    }
    console.log("stats_current.cu", this.stats_current)
    if (data.pat_stats && data.pat_stats.length > 0) {
      //this.forms.reasonForm.value;
      var stats_std_val;
      data.pat_stats.forEach((x, index) => {
        x.stats_std_val = String(x.stats_std_value);
        x.aid = parseInt(this.cid);
        x.pid = parseInt(this.pids);
        x.stats_date_time = current_date;
        x.id = this.stats_current[index].id
        x.stats_by = this.drid;
        delete x.stats_std_value;
        delete x.stats_std_uom;
        delete x.stats_name;
      });
    }
    data.patient_consult_stats = data.pat_stats;
    delete data.pat_stats;
    if (data.patient_checkin_stats && data.patient_checkin_stats.length === 0) {
      delete data.patient_checkin_stats;
    }
    data = Utils.removeNullAndEmpty(data);
    console.log("data.patient_appetite", data.patient_appetite)
    if (data.patient_appetite && data.patient_appetite.length > 0) {
      data.patient_appetite.forEach((x, index) => {
        x.ap_date = current_date;

        if (x.since === '') {
          console.log("since is empty");
          x.since = 0;
          //delete (x.since)
        }
        data.patient_appetite[index] = Utils.removeNullAndUndefined(
          data.patient_appetite[index]
        );
      });
    }



    if (data.patient_lifestyle && data.patient_lifestyle.length > 0) {
      data.patient_lifestyle.forEach((x, index) => {
        x.ap_date = current_date;
        data.patient_lifestyle[index] = Utils.removeNullAndUndefined(
          data.patient_lifestyle[index]
        );
      });
    }
    if (data.patient_appetite && data.patient_appetite.length === 0) {
      delete data.patient_appetite;
    }
    if (data.patient_appetite) {
      data.patient_consult_appetite = data.patient_appetite
      delete data.patient_appetite;
    }
    if (data.patient_lifestyle) {
      data.patient_consult_lifestyle = data.patient_lifestyle
      delete data.patient_lifestyle;
    }
    console.log("--------------DATA-----------------------", data);
    this.addPService.saveConsult_dtails(data).subscribe(
      () => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "success",
          title: "Consultation Saved",
        });
        this.refresh();
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  public showFormArrayVal(index, arrayName, key) {
    let val, val2;
    val = this[arrayName].value[index][key];
    if (arrayName === "patient_med_history" && key === "disease_id") {
      this.diseaseList.forEach((element) => {
        if (element.id == val) {
          val = element.disease_name;
        }
      });
    }

    if (arrayName === "patient_appetite" && key === "habit_id") {
      if (this.patient_appHabbitsList[val - 1]) {
        val = this.patient_appHabbitsList[val - 1].description;
      }

    }

    if (arrayName === "medicine_template" && key === "tmpl_id") {
      if (this.patient_appHabbitsList[val - 1]) {
        val = this.patient_appHabbitsList[val - 1].mname;
      }

    }


    if (arrayName === "pat_stats" && key === "stats_name") {
      if (this.stats_current[val - 1]) {
        val = this.stats_current[val - 1].stats_name;

      }

    }

    if (arrayName === "pat_stats" && key === "stats_id") {
      if (this.stats_current[val - 1]) {
        val = this.stats_current[val - 1].stats_std_value;
        val = this.stats_current[val - 1].stats_std_uom;
      }

    }

    if (key === "stats_std_value") {
      if (val === null || val === 0 || val === "null") {
        val = this.displayNames[key];

      }
    }


    if (key === "since" && val === 0) {
      // this[arrayName].value[index][key] = "0";
      // val = "0";
      val = this.displayNames[key];
      return val;
    } else if (key === "since" && val === null) {
      val = this.displayNames[key];
    }

    if (!val && key != "since") {
      val = this.displayNames[key];
    }

    return val;
  }

  formValidation(i, key, arrayName) {
    let error = false;
    if (
      this.forms["medicalInformation"].get([arrayName]).controls[i] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
      key
      ] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
        key
      ].errors
    ) {
      error = true;
    }
    return error;
  }

  addNewFormArray(arrayName) {
    console.log("arrayName", arrayName)
    this[arrayName] = this.forms[this.editCurrentTab].get([
      arrayName,
    ]) as UntypedFormArray;

    if (arrayName === "patient_med_history") {
      this[arrayName].push(this.createHistory(null, null, null));
    }
    if (arrayName === "patient_medication") {
      this[arrayName].push(this.createMedication(null, null, null));
    }
    if (arrayName === "patient_appetite") {
      this[arrayName].push(this.createApetite(null, null, null, null, null, null, null));

    }
    if (arrayName === "medicine_template") {
      this[arrayName].push(this.createMedicine(null, null));

    }

    if (arrayName === "pat_stats") {
      this[arrayName].push(this.createStats(null, null, null, null));
    }
    if (arrayName === "patient_lifestyle") {
      this[arrayName].push(this.createLifestyle(null, null, null, null, null));
    }
    if (arrayName === " patient_fmed_history") {
      this[arrayName].push(this.createPatfmedhistory(null, null, null, null, null, null, null));
    }
  }

  isSelected(disease_id) {
    return this.forms.medicalInformation
      .get("patient_med_history")
      .value.find((item) => disease_id === item.disease_id);
  }

  public removeFromList(list, i) {
    this[list].removeAt(i);
  }


  checkedNo(evt, i) {
    this.patient.patient_appetite[i].has_habit = false;
    console.log(
      "false as has_habit",
      this.patient.patient_appetite[i].has_habit
    );
    console.log("patient info", this.patient.patient_appetite);
  }

  checkedYes(evt, i) {
    this.patient.patient_appetite[i].has_habit = true;
    console.log(
      "true as has_habit",
      this.patient.patient_appetite[i].has_habit
    );
    console.log("patient info", this.patient.pat0939d8ient_appetite);
  }

  public getYears() {
    const resultArray = [];

    for (let i = 1950; i <= (new Date()).getFullYear(); i++) {
      resultArray.push(i);
    }
    this.yearList = resultArray.reverse();
    console.log(this.yearList);
  }

  public getStatsLabel(i) {
    return this.statslist[i].stats_name;
  }


  public getStatsuom(i) {
    return this.statslist[i].stats_std_uom;
  }




  getStatsList() {
    this.addPService.getstatList().subscribe(
      (res) => {
        console.log("STATS::", res);
        this.statslist = res;
      },
      (error) => { }
    );
  }

  addStats(id): UntypedFormGroup {
    return this.fb.group({
      stats_id: [id],
      stats_value: [],
    });
  }



  getStatDetail() {
    let pid = this.pid;
    let aid = this.aid;
    this.patService
      .getStat_detail({ pid, aid })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.appointment = res;

          console.log("getStatDetail()", res);
          console.log("***************************************      stats     *********************************")
          this.stats_current = res.Current_stats
          console.log(" Retrive the stats values from DB :", this.stats_current)
          res.Current_stats.forEach((x, index) => {
            if (x.stats_std_val === "null" || x.stats_std_val === null || x.stats_std_val === 0 || x.stats_std_val === "undefined") {
              console.log("x.stats_std_valx.stats_std_val", x.stats_std_val)
              x.stats_std_val = null;
            }
            if (x.stats_std_val != null && x.stats_std_val_from != null && x.stats_std_val_to != null) {
              if (x.stats_std_val >= x.stats_std_val_from && x.stats_std_val <= x.stats_std_val_to) {
                x.compare = "green";
                //return x;
              } else if (x.stats_std_val < x.stats_std_val_from) {
                x.compare = "orange";
                //return x;
              } else if (x.stats_std_val > x.stats_std_val_to) {
                x.compare = "red";

              } return x;
            }
            if (x.stats_std_val != null && x.stats_std_val_from != null && x.stats_std_val_to == null) {

              if (x.stats_std_val >= x.stats_std_val_from) {
                x.compare = "green";
                //return x;
              } else {
                x.compare = "red";

              } return x;
            }
            if (x.stats_std_val != null && x.stats_std_val_to != null && x.stats_std_val_from == null) {

              if (x.stats_std_val <= x.stats_std_val_to) {
                x.compare = "green";
                //return x;
              } else {
                x.compare = "red";

              } return x;
            }
            if (x.stats_std_val != null && x.stats_std_val_to == null && x.stats_std_val_from == null) {


              x.compare = "blue";
              return x;
            }

          });

          console.log(" Retrive the stats values from DB 2:", this.stats_current)
        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  // Preview document fetch function
  async previewDocuments(doc: any) {
    let uri = environment.content_base_url + "/" + doc;
    if (Utils.allowedImageFormats.includes(doc.split('.').pop())) {
      Swal.fire({
        imageUrl: doc,
        showConfirmButton: false,
        showCloseButton: true,
      })
    } else {

      this.pdfSrc1 = doc;
      console.log(this.pdfSrc1);
      const files = { name: doc.name, type: doc.type };
      this.pdfSrc = doc;

      this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });

    }
    // }
  }
  getPreviousStatDetail(i) {
    let pid = this.pid;
    let stats_id = i;
    this.spinner.show();
    this.patService
      .getStat_detail({ pid, stats_id })
      .subscribe(
        (res) => {
          console.log("=res=", res)
          this.spinner.hide();
          res.previous_stats.forEach((element) => {
            if (element.stats_std_val === "undefined" || element.stats_std_val === "null") {
              element.stats_std_val = null;
            }
          });
          // res.previous_stats.forEach((element) => {
          //   if (element.stats_std_val === "undefined" && element.stats_std_val === "null") {
          //     element.stats_std_val = null;
          //   }
          // });

          this.previous_stats = res.previous_stats;
          console.log("this.previous_stats()", this.previous_stats);

        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }


  // SEARCH TEMPLATE from search button click
  searchtmpl() {
    this.tmpl_expa = true;

    let data = { ...this.tmpl_search_form.value };
    console.log(
      "this.forms.appetiteHabits s1", this.forms.appetiteHabits.value.medicine_template
    )
    this.templateForm();
    delete this.forms.appetiteHabits.value.medicine_template
    data.org_code = localStorage.getItem("orgcode");
    data.drid = parseInt(localStorage.getItem("uid"));

    if (data.tmpl_name == "") {
      delete data.tmpl_name;
    }
    console.log(data);

    this.spinner.show();
    this.service
      .sarchpresTempl(data)
      .subscribe(
        (res) => {
          // window.location.reload();
          this.spinner.hide();
          console.log(
            "this.forms.appetiteHabits s2", this.forms.appetiteHabits.value.medicine_template
          )
          this.cate = res;
          this.unique = [...new Map(this.cate.map((m) => [m.tmpl_id, m])).values()];
          for (let apetite of res) {
            this.medicine_template = this.forms.appetiteHabits.get(
              "medicine_template"
            ) as UntypedFormArray;
            this.medicine_template.push(this.addAppetites(apetite.tmpl_id));
          }
        },
        (error) => {
          console.log(error);
        }
      );

  }


  removeuntypeformReset(): void {
    this.forms.appetiteHabits.reset();
    this.tmpl_search_form.reset();
    // this.medicine_template.reset();
    // delete this.medicine_template;
  }


  //Chat Functionality


  subscribeToChatMessage() {
    this.service.consultNowUpdate.subscribe((data: any) => {
      this.sendJoinChatNotification();
      // this.messages.push({ id: 1118, body: "how are you?", date: moment().toDate() });
      // this.messages.push({ id: 1118, body: "how can I help you?", date: moment().toDate() });
      // //this.messages.push({ id: data.uid, body: data.message, date: moment().toDate() });
    });
  }

  sendJoinChatNotification() {
    let data = { u_id: parseInt(this.pid) };
    data["id"] = parseInt(this.drid);
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = "Physician has Joined the ChatRoom";
    data["type"] = Utils.NOTIFICATION_TYPES.JOIN_CHAT;
    this.realTimeService.send(data);
  }
  sendStatusTyping(event) {
    //keycode of enter is 13
    if (event.keyCode !== 13 && this.currentStatus !== "Typing") {
      this.currentStatus = "Typing";
      //send to websocet
      this.sendStatus();
    }
  }

  sendStatus() {
    let data = { u_id: parseInt(this.pid) };
    data["id"] = parseInt(this.drid);
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = this.currentStatus;
    data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
    this.realTimeService.send(data);
  }

  sendMessage() {
    this.currentStatus = "";
    //u_id is the id to which we are sending messages
    let data = { u_id: parseInt(this.pid) };
    //id is the id from which we are sending messages
    data["id"] = parseInt(this.drid);
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.NEW_MESSAGE;
    data["aptid"] = this.room_id;
    data["contentType"] = "text";
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PHYSICIAN;

    if (this.chatForm.get("chat_msg").value) {
      data["message"] = this.chatForm.get("chat_msg").value;
      this.realTimeService.send(data);
    }
    if (this.chatForm.get("chat_msg").value) {
      this.messages.push({
        id: JSON.parse(localStorage.getItem("uid")),
        u_id: parseInt(this.pid),
        body: this.chatForm.get("chat_msg").value,
        date: moment().toDate(),
      });
      setTimeout(() => {
        this.chatForm.patchValue({ chat_msg: "" });
        this.chatForm.get("chat_msg").updateValueAndValidity();
      }, 100);
    }
  }

  async selectFile(event) {
    let data = { u_id: parseInt(this.pid) };
    data["id"] = parseInt(this.drid);
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.SEND_ATTACHMENT;
    data["aptid"] = this.room_id;
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PHYSICIAN;
    let {
      target: { files },
    } = event;
    let [file] = files;
    let reader = new FileReader();
    if (file) {
      let previewUrl;
      if (file.size > this.maxFileSize) {
        this.showToast("error", "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      reader.readAsDataURL(file);
      data["name"] = file.name;
      reader.onload = (event: any) => {
        previewUrl = event.target.result;
        // this.messages[this.messages.length - 1].body["previewUrl"] = previewUrl.toString();
        this.messages.push({
          id: parseInt(this.drid),
          u_id: parseInt(this.pid),
          body: { contentType: file.type, previewUrl, name: file.name },
          date: moment().toDate(),
        });
      };
      //get signed url and upload on S3
      await this.service
        .uploadFile(
          {
            room_id: this.room_id,
            aptid: this.room_id,
            file: { name: file.name, type: file.type },
          },
          file
        )
        .subscribe(
          (res) => {
            this.attachmentSignedUrl = res.signedUrl;
            this.Imagekey = res.key;
            data["contentType"] = file.type;
            data["message"] = this.Imagekey;
            this.realTimeService.send(data);
            this.spinner.hide();
          },
          (error) => {
            this.spinner.hide();
            this.showToast("error", "Something went wrong.Please try again !");
          }
        );
    }
  }

  previewImg(i) {
    console.log(this.messages[i]);

    if (
      Utils.IMGFILE ==
      this.messages[i].body["contentType"].substring(
        0,
        this.messages[i].body["contentType"].indexOf("/")
      )
    ) {
      Swal.fire({
        imageUrl: this.messages[i].body["previewUrl"],
        showConfirmButton: false,
        showCloseButton: true,
      });
    } else {
      this.pdfSrc = this.messages[i].body["previewUrl"];
      this.modal.open(this.PDFModal, {
        size: "lg",
        centered: true,
        backdrop: "static",
      });
    }
  }

  updateRoomId() {
    console.log("111111111111111111111  updateRoomId  11111111111111111111111")
    let data = { room_id: this.room_id };
    this.service.fetchRoomIDPhy(data).subscribe((res) => {
      this.room_id = res.room_id;
      this.subscribeToChatMessage();
    });
    this.showChatModal = false;
  }

  notifyCall(type) {
    console.log("type", type)
    console.log("this.showOnlineJoinCall", this.showOnlineJoinCall)
    if (this.showOnlineJoinCall) {
      this.isMinimize = false;
      return;
    }
    this.showOnlineJoinCall = true;
    let data = { u_id: parseInt(this.pid) };
    data["id"] = parseInt(this.drid);
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.NOTIFICATION_TYPES.ENABLE_ONLINE_CALL;
    // if (type === Utils.APPOINTMENT_TYPE.AUDIO) {
    //   data["message"] = Utils.ENABLE_CALL.AUDIO;
    // } else {
    data["message"] = Utils.ENABLE_CALL.VIDEO;
    //}
    this.realTimeService.send(data);
    console.log("data", data)
  }

  checkMsgType(body) {
    if (body) {
      if (typeof body === "string") {
        return typeof body;
      } else {
        return body["contentType"].substring(
          0,
          body["contentType"].indexOf("/")
        );
      }
    }
  }

  getPhysicianDetails() {
    this.service.getPhysicianById(localStorage.getItem("uid")).subscribe(
      (result) => {
        this.physicianDetail = result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async startChat() {
    this.chatStarted = true;
    this.chatMessageSub = this.service.chatMessageSubject.subscribe((value) => {
      const values: ChatMessages = { ...value };
      if (values.type === Utils.CHAT_ACTION.NEW_MESSAGE) {
        this.messages.push({
          id: values.id,
          body: values.message,
          date: moment().toDate(),
        });
      } else if (values.type === Utils.CHAT_ACTION.SEND_ATTACHMENT) {
        this.messages.push({
          id: values.id,
          body: {
            previewUrl: values.message.toString(),
            contentType: values.contentType,
            name: values.name,
          },
          date: moment().toDate(),
        });
      } else if (values.type === Utils.NOTIFICATION_TYPES.TYPING_STATUS) {
        this.typingStatus = { status: values.message };
      } else if (values && values.type === Utils.messageAction.GETMESSAGES) {
        values.data.forEach((value) => {
          if (value.contentType == "text") {
            this.messages.push({
              id: value.id,
              body: value.body,
              date: value.msg_time,
            });
          } else {
            this.messages.push({
              id: value.id,
              body: {
                previewUrl: value.body.toString(),
                contentType: value.contentType,
                name: value.name,
              },
              date: value.date,
            });
          }
        });
      }
    });
    this.getChatHistory();
  }

  getChatHistory() {
    let data = {};
    data["u_id"] = parseInt(this.drid);
    data["aptid"] = this.room_id;
    data["room_id"] = this.room_id;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["type"] = this.messageAction.GETMESSAGES;
    this.realTimeService.send(data);
  }
  enterSubmit(event) {
    if (event.keyCode == 13 && !event.shiftKey) {
      //Stops enter from creating a new line
      event.preventDefault();
      return true;
    }
  }

  closePopUp() {
    this.modalRef.close();
  }
  ngOnDestroy() {
    this.chatForm.reset();
    if (this.chatMessageSub) {
      this.chatMessageSub.unsubscribe();
    }
    if (this.chatJoinSub) {
      this.chatJoinSub.unsubscribe();
    }
  }



}


